/*global define, console, window, HTMLImageElement, Promise*/

(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("EventCalendar", ["jquery", "Behaviors"], factory);
    } else {
        root.EventCalendar = factory(root.jQuery, root.Behaviors);
    }
}(this, function ($, Behaviors) {
    "use strict";
    var module = {};

    function EventCalendar() {
        Behaviors.init(EventCalendar, this, arguments);
        this.element = this.$elem[0];

         //clone year filter from calendar

         var sc_year_clone = $('#sc_year').clone();

         sc_year_clone.attr('id','filter-year');
 
         sc_year_clone.appendTo('#event-year-filter-wrapper');

         $(EventCalendar.ELEMENTS.FilterMonth).val( $(EventCalendar.ELEMENTS.CalendarMonth).val() ); //mimick calendar month value

         $(EventCalendar.ELEMENTS.CalendarEventType).val( DEFAULT_ACTIVE_FILTER ); //mimick calendar event filter value

         $(EventCalendar.ELEMENTS.CalendarSubmit).trigger("click");
         setTimeout( function(){
                processQuery(); //pass default filter
                console.log('---first ajax call');
        },6000);


        // setTimeout( function(){

        //     //$(EventCalendar.ELEMENTS.FilterEventTypes).val( DEFAULT_ACTIVE_FILTER ).change(); // initial state

        //     //$(EventCalendar.ELEMENTS.FilterEventTypes).trigger("click");

        // },2000);


        $(EventCalendar.ELEMENTS.FilterMonth).on( 'change',function(){

            $(EventCalendar.ELEMENTS.CalendarMonth).val( $(this).val() ).change();

            $(EventCalendar.ELEMENTS.CalendarSubmit).trigger("click");

            processQuery();

        });

        $(EventCalendar.ELEMENTS.FilterYear).on( 'change',function(){

            $(EventCalendar.ELEMENTS.CalendarYear).val( $(this).val() ).change();

            $(EventCalendar.ELEMENTS.CalendarSubmit).trigger("click");

            processQuery();

        });

        $(EventCalendar.ELEMENTS.FilterRegion).on( 'change',function(){
            processQuery();
        });

        $(EventCalendar.ELEMENTS.FilterEventTypes).on( 'change',function(){

            $(EventCalendar.ELEMENTS.CalendarEventType).val( $(this).data("event-type") ).change();

            $(EventCalendar.ELEMENTS.CalendarSubmit).trigger("click");

            processQuery();
        });
        
    }

    function processQuery(){
        //check active filters

        let params = [];

        $(EventCalendar.ELEMENTS.EventsWrapper).html('<p class="no-events">Searching for events...</p>');

        if( $(EventCalendar.ELEMENTS.FilterMonth + ' option').filter(":selected").val() ){
            params.push({ 'key' : 'event_month', 'value' : $(EventCalendar.ELEMENTS.FilterMonth).val() });
        }

        if( $(EventCalendar.ELEMENTS.FilterYear + ' option').filter(":selected").val() ){
            params.push({ 'key' : 'event_year', 'value' : $(EventCalendar.ELEMENTS.FilterYear).val() });
        }

        if( $(EventCalendar.ELEMENTS.FilterRegion + ' option').filter(":selected").val() !== "---" ){
            params.push({ 'key' : 'event_region', 'value' : $(EventCalendar.ELEMENTS.FilterRegion).val() });
        }

        params.push({ 'key' : 'event_type', 'value' : $(EventCalendar.ELEMENTS.FilterEventTypes + ":checked").val() });
        
       

        //console.log(params);

        //build URL request
        let param_url ='';
        for( var i=0; i < params.length; i++){
            param_url +=  ( i == 0 ?"?" : "&" ) + params[i].key + "=" + params[i].value;
        }

        //console.log(param_url);
        let ajax_url = REST_EVENT_ENDPOINT + param_url;

        //console.log(ajax_url);

        $.ajax(
            ajax_url,
            {
                success: function(data) {

                    //console.log( data['events'] );

                    let previousDay = '';
                    let html = '';


                    if(data['events'].length > 0){

                    

                        for(var i=0 ; i < data['events'].length; i++){

                            let item = data['events'][i];

                        //console.log(item);

                            //check if same day
                            if( item.event_start !== previousDay){
                                previousDay =  item.event_start;

                                html += `<h4>${item.event_start}</h4>`;
                            }

                            let timeInfo = '';

                            if(  item.event_end_full.endsWith('23:59:59') == false){
                                //end date/time not specified
                                timeInfo = item.event_start_time + " - " + item.event_end_time
                            }

                            html += `<p class="time-info">${timeInfo}</p>
                                        <p><b class="event-name">${item.title }</b></p>
                                        <p class="event-description">${item.description}</p>`;

                                        // <p>region: ${item.region.name}</p>
                                        // <p>type: ${item.type.name}</p>;
                            $(EventCalendar.ELEMENTS.EventsWrapper).html(html);

                        }
                    }else{

                        $(EventCalendar.ELEMENTS.EventsWrapper).html('<p class="no-events">No matching events found.</p>');
                    }
                      
                       
                   


                },
                error: function() {
                    console.log('There was some error performing the AJAX call!');
                }
            }
        );

    }

    Behaviors.inherit(EventCalendar, Behaviors.Behavior);

    EventCalendar.QUERY = "[data-EventCalendar]";

    EventCalendar.ELEMENTS = {
        CalendarWrapper : "#event-calendar-wrapper",
        EventsWrapper : "#events-wrapper",
        FilterMonth : "#filter-month",
        FilterYear : "#filter-year",
        FilterRegion : "#filter-region",
        FilterEventTypes : 'input[name="eventtype"]',
        CalendarMonth : "#sc_month",
        CalendarYear : "#sc_year",
        CalendarEventType : "#sc_event_category",
        CalendarSubmit: "#sc_submit"
    };
    
    Behaviors.register_behavior(EventCalendar);

    module.EventCalendar = EventCalendar;

    return module;
}));
